"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNavigationType = void 0;
const enums_1 = require("../enums");
const getNavigationType = () => {
    const navitation = performance.getEntriesByType("navigation")[0];
    const navigationType = navitation.type;
    if (navigationType === "navigate") {
        return enums_1.Navigation.NAVIGATION;
    }
    if (navigationType === "reload") {
        return enums_1.Navigation.REFRESH;
    }
    if (navigationType) {
        return enums_1.Navigation.ALTERNATIVE;
    }
    return enums_1.Navigation.UNKNOWN;
};
exports.getNavigationType = getNavigationType;
